"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTransactionAttributes$ = exports.PropertyTransactionAttributes$outboundSchema = exports.PropertyTransactionAttributes$inboundSchema = void 0;
exports.propertyTransactionAttributesToJSON = propertyTransactionAttributesToJSON;
exports.propertyTransactionAttributesFromJSON = propertyTransactionAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.PropertyTransactionAttributes$inboundSchema = z.object({
    date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    is_new_build: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    price: z.number().int(),
    transaction_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "is_new_build": "isNewBuild",
        "transaction_id": "transactionId",
    });
});
/** @internal */
exports.PropertyTransactionAttributes$outboundSchema = z.object({
    date: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    isNewBuild: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    price: z.number().int(),
    transactionId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        isNewBuild: "is_new_build",
        transactionId: "transaction_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyTransactionAttributes$;
(function (PropertyTransactionAttributes$) {
    /** @deprecated use `PropertyTransactionAttributes$inboundSchema` instead. */
    PropertyTransactionAttributes$.inboundSchema = exports.PropertyTransactionAttributes$inboundSchema;
    /** @deprecated use `PropertyTransactionAttributes$outboundSchema` instead. */
    PropertyTransactionAttributes$.outboundSchema = exports.PropertyTransactionAttributes$outboundSchema;
})(PropertyTransactionAttributes$ || (exports.PropertyTransactionAttributes$ = PropertyTransactionAttributes$ = {}));
function propertyTransactionAttributesToJSON(propertyTransactionAttributes) {
    return JSON.stringify(exports.PropertyTransactionAttributes$outboundSchema.parse(propertyTransactionAttributes));
}
function propertyTransactionAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyTransactionAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyTransactionAttributes' from JSON`);
}
//# sourceMappingURL=propertytransactionattributes.js.map